module.exports = __webpack_public_path__ + "arrow_left_back_to_list.f521a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/arrow_left_back_to_list.svg
// module id = ./src/_asset/sources/assets/images/@svg/arrow_left_back_to_list.svg
// module chunks = main